export { default } from './googleAnalytics'
